










































































































import { storeRiwayat } from "@/store/modules/riwayat";
import { Component, Vue, Watch } from "vue-property-decorator";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { pemeriksaanRouteName } from "@/utils/unit";
import { buildPemeriksaanLocation } from "@/utils/actingUnit";
import { bersihkanDetailKunjungan } from "@/utils/riwayatKunjungan";
import { UnitJourneySegment } from "@/types/riwayat";

interface ItemRiwayat {
  register: string | number;
  masuk: string;
  keluar: string;
  unit?: { id?: string; nama?: string };
  unit_asal?: string;
  unit_asal_nama?: string;
  unit_journey?: { segments?: UnitJourneySegment[] };
}

@Component({
  components: {}
})
export default class CardListKunjungan extends Vue {
  created() {}

  expanded: ItemRiwayat[] = [];

  get headers() {
    return [
      { text: "Tgl Masuk", value: "masuk" },
      { text: "Tgl Keluar", value: "keluar" },
      { text: "Unit Awal", value: "unitAwal", sortable: false },
      { text: "Unit Akhir", value: "unitAkhir", sortable: false },
      { text: "Aksi", value: "aksi", sortable: false, align: "end" }
    ];
  }

  get listriwayat() {
    return storeRiwayat.listriwayat;
  }

  get loading(): boolean {
    return storeRiwayat.loadingListRiwayat;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get unitLogin(): string {
    return userModule.loginUnitId || "";
  }

  @Watch("$route")
  onRouteChange() {
    this.expanded = [];
  }

  unitAwal(item: ItemRiwayat): string {
    return item.unit_asal_nama || item.unit_asal || this.unitAkhir(item);
  }

  unitAkhir(item: ItemRiwayat): string {
    return item.unit?.nama || item.unit?.id || "-";
  }

  unitAnda(seg: UnitJourneySegment): boolean {
    return !!this.unitLogin && seg.unit.id === this.unitLogin;
  }

  tglRingkas(v: string): string {
    if (!v) return "-";

    return v.replace(/-/g, "/");
  }

  waktuSegmen(v: string | null): string {
    if (!v) return "-";
    const [tgl, jam] = v.split(" ");
    const [y, m, d] = tgl.split("-");

    return `${d}/${m}/${y} ${(jam || "").slice(0, 5)}`.trim();
  }

  jumlahSegmen(item: ItemRiwayat): number {
    const segments = item?.unit_journey?.segments;

    return segments ? segments.length : 0;
  }

  bukaLangsung(item: ItemRiwayat) {
    const segments = item?.unit_journey?.segments ?? [];

    if (segments.length === 1) {
      this.bukaSegmen(item, segments[0]);
      return;
    }

    this.bukaRiwayat(item);
  }

  segmenList(item: ItemRiwayat): UnitJourneySegment[] {
    const segments = item?.unit_journey?.segments ?? [];

    return segments.slice().reverse();
  }

  isDibuka(item: ItemRiwayat): boolean {
    return this.expanded.some(
      e => String(e.register) === String(item.register)
    );
  }

  toggleBuka(item: ItemRiwayat) {
    this.expanded = this.isDibuka(item) ? [] : [item];
  }

  handleClick(item, row) {
    row.select(true);
    bersihkanDetailKunjungan();

    this.$emit("dataPasien", item);
  }

  bukaSegmen(item: ItemRiwayat, seg: UnitJourneySegment) {
    const rm = this.pasien?.rm;
    if (!rm) return;

    const adaRanap = (item?.unit_journey?.segments ?? []).some(
      s => s.kind === "ranap"
    );

    this.$router
      .push(
        buildPemeriksaanLocation(item.register, rm, seg.unit.id, {
          hasRanapSegment: adaRanap
        })
      )
      .catch(() => undefined);
  }

  bukaRiwayat(item: ItemRiwayat) {
    const rm = this.pasien?.rm;
    if (!rm) return;

    this.$router
      .push({
        name: pemeriksaanRouteName(item.unit?.id, item.unit_asal),
        params: { register: String(item.register), rm: String(rm) }
      })
      .catch(() => undefined);
  }
}
